<template>
  <v-container fluid>
    <!-- Título -->
    <v-row>
      <v-col cols="12">
       
      </v-col>
    </v-row>
    <!-- Botón de exportar CSV -->
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn color="primary" @click="exportarFlujosCaja">
          {{ $t('comun.boton_exportar') }}
        </v-btn>
      </v-col>
    </v-row>
    <!-- Tarjetas LCOE -->
    <v-row class="mt-6 justify-center">
      <v-col cols="12" md="4">
        <v-card class="pa-4 text-center stat-card">
          <v-card-title class="text-h4 font-weight-bold">
            {{ lcoePV != null ? lcoePV.toFixed(2) : '-' }} EUR/MWh
          </v-card-title>
          <v-card-subtitle class="text-subtitle-1">
            {{ $t('simulacion.modulo.resultado.flujos-caja.lcoe_pv') || 'LCOE solar PV' }}
          </v-card-subtitle>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="pa-4 text-center stat-card">
          <v-card-title class="text-h4 font-weight-bold">
            {{ lcoeEOL != null ? lcoeEOL.toFixed(2) : '-' }} EUR/MWh
          </v-card-title>
          <v-card-subtitle class="text-subtitle-1">
            {{ $t('simulacion.modulo.resultado.flujos-caja.lcoe_eolica') || 'LCOE eólica' }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <!--  gráfica Cashflow -->
    <v-row>
      <v-col cols="12">
        
        <ComponenteGrafica :options="graficaCashflow" height="650px"  />
      </v-col>
    </v-row>

   <!-- Tabla Cashflow  -->
<v-row>
  <v-col cols="12">
    <h3>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_cashflow') }}</h3><br>
    <table class="my-cashflow-table">
      <thead>
        <tr>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_anio') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_capex') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_capex-revamping') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_subvencion') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_subvencion_uni') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_capex-res') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_opex-electrico') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_opex-h2') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_opex-res') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_ingresos-electrico') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_ingresos-h2-verde') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_ingresos-h2-lowcarbon') }}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosVallowcarbon')}}</th>
          <th>{{ $t('simulacion.modulo.resultado.flujos-caja.tabla_cf-total') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(fila, index) in tablaCashflow" :key="index">
          <td>{{ fila.anio }}</td>
          <td>{{ fila.capex }}</td>
          <td>{{ fila.capexRevamping }}</td>
          <td>{{ fila.subvencion }}</td>
          <td>{{ fila.subvencion_uni }}</td>
          <td>{{ fila.capexRES }}</td>
          <td>{{ fila.opexElec }}</td>
          <td>{{ fila.opexH2 }}</td>
          <td>{{ fila.opexRES }}</td>
          <td>{{ fila.ingresosElec }}</td>
          <td>{{ fila.ingresosH2verde }}</td>
          <td>{{ fila.ingresosH2lowcarbon }}</td>
          <td>{{ fila.ingresosVallowcarbon }}</td>
          <td>{{ fila.cfTotal }}</td>
        </tr>
      </tbody>
    </table>
  </v-col>
</v-row><br>

<!-- Gráfico Cascada  -->
<v-row>
  <v-col cols="12">
    <h3>{{ $t('simulacion.modulo.resultado.flujos-caja.grafica_cascada') }}</h3>
    <ComponenteGrafica :options="graficaCascada" />
  </v-col>
</v-row>
  </v-container>
</template>


<script>
import ComponenteGrafica from '../components/ComponenteGrafica.vue';

export default {
  props: {
    resumen_flujos_caja: {
      type: Array,
      required: true,
    },
    datos_sal_an2: {       
      type: Array,
      required: true,
    },
    datos_sal_an2_total: {   
      type: Array,
      required: true,
  },
   datos_sal_an: {       
      type: Array,
      required: true,
    },
  diagrama: { type: Object, required: false, default: () => ({}) },
  },

  computed: {
    
lcoePV() {
      const v = this.diagrama?.LCOE_PV;
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
    },
    lcoeEOL() {
      const v = this.diagrama?.LCOE_EOL;
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
    },
     //  Tabla Cashflow 
    tablaCashflow() {
  // Quitamos TOTAL de ambos arrays y nos quedamos con los años
  const datosSalAn2 = this.datos_sal_an2
    .filter(d => String(d.Year).trim().toUpperCase() !== 'TOTAL');

  const datosSalAn = this.datos_sal_an
    .filter(d => String(d.Year).trim().toUpperCase() !== 'TOTAL');

  return datosSalAn2.map((d2, index) => {
    const d1 = datosSalAn[index] || {};

    // OPEX planta H2 = -C_AGUA - C_OYMEL - C_OYMPL (de sal_an.out)
    const opexPlantaH2 =
      -(
        (parseFloat(d1.C_AGUA)  || 0) +
        (parseFloat(d1.C_OYMEL) || 0) +
        (parseFloat(d1.C_OYMPL) || 0)
      );

    return {
      anio: String(d2.Year).replace(/^a/i, ''),

      capex:           (parseFloat(d2.CAPEX_H2)  || 0).toFixed(2),
      capexRevamping:  (parseFloat(d2.CAPEX_REV) || 0).toFixed(2),
      subvencion:      (-(parseFloat(d1.CAPEX_SUBV) || 0)).toFixed(2),
      subvencion_uni:  (-(parseFloat(d1.H2V_SUBV)  || 0)).toFixed(2),
      capexRES:        (parseFloat(d2.CAPEX_RES) || 0).toFixed(2),

      opexElec:        (parseFloat(d2.OPEX_ELEC) || 0).toFixed(2),
      opexH2:          opexPlantaH2.toFixed(2),
      opexRES:         (parseFloat(d2.OPEX_RES)  || 0).toFixed(2),

      ingresosElec:        (parseFloat(d2.ING_ELEC) || 0).toFixed(2),
      ingresosH2verde:     (parseFloat(d2.ING_H2V) || 0).toFixed(2),
      ingresosH2lowcarbon: (parseFloat(d2.ING_H2L) || 0).toFixed(2),
      ingresosVallowcarbon: (parseFloat(d1.I_ExLC) || 0).toFixed(2),

      cfTotal: (parseFloat(d2.CF_TOTAL) || 0).toFixed(2),
    };
  });
},



    //  Cabeceras para la tabla Cashflow
    headersCashflow() {
      return [
        { text: 'Año', value: 'anio' },
        { text: 'CAPEX', value: 'capex' },
        { text: 'CAPEX Revamping', value: 'capexRevamping' },
        { text: 'Subvención', value: 'subvencion' },
        { text: 'Subvenciones unitarias', value: 'subvencion_uni' },
        { text: 'CAPEX RES', value: 'capexRES' },
        { text: 'OPEX eléctrico', value: 'opexElec' },
        { text: 'OPEX planta H2', value: 'opexH2' },
        { text: 'OPEX RES', value: 'opexRES' },
        { text: 'Ingresos eléctricos', value: 'ingresosElec' },
        { text: 'Ingresos H2 verde', value: 'ingresosH2verde' },
        { text: 'Ingresos H2 low-carbon', value: 'ingresosH2lowcarbon' },
        { text: 'Ingresos valoración low-carbon', value: 'ingresosVallowcarbon' },
        { text: 'CF operativo pre-tax', value: 'cfTotal' },
      ];
    },


   graficaCascada() {
  if (!this.datos_sal_an2.length) return {};

  const totales = this.datos_sal_an2_total && this.datos_sal_an2_total.length > 0 ? this.datos_sal_an2_total[0] : null;
  if (!totales) return {};

  const categorias = [
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capex'), value: parseFloat(totales.LCOH_CPXPL) || 0 },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capexRevamping'), value: parseFloat(totales.LCOH_CPXRV) || 0 },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.subvencion'), value: parseFloat(totales.LCOH_CPXSBV) || 0 },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capexRES'), value: parseFloat(totales.LCOH_CPXRES) || 0 },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexElec'), value: parseFloat(totales.LCOH_OPXEL) || 0 },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexH2'), value: parseFloat(totales.LCOH_OPXPL) || 0 },
  {
    name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexRES'),
    value:
      (parseFloat(totales.LCOH_OPXPV) || 0) +
      (parseFloat(totales.LCOH_OPXEOL) || 0) ||
      (parseFloat(totales.LCOH_OPXRES) || 0) // fallback si aún viene el campo antiguo
  },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosElec'), value: this.sumIngresosLCOH(totales) || 0 },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.otrosIngresos'), value: (parseFloat(totales.LCOH_INGOTR)) || 0 },
  //{ name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.amortizacion'), value: parseFloat(totales.LCOH_AMORT) || 0 },
  { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.LCOH'), value: parseFloat(totales.LCOH_TOTAL) || 0 },
];


  const assistData = [];
  let acumulado = 0;

  const dataAumento = [];
  const dataDisminucion = [];
  const dataTotal = [];

  for (let i = 0; i < categorias.length; i++) {
  const val = categorias[i].value;

    if (i < categorias.length - 1) {
      if (val >= 0) {
        assistData.push(acumulado);        
        dataAumento.push(val);            
        dataDisminucion.push(0);
      } else {
        assistData.push(acumulado + val);  
        dataAumento.push(0);
        dataDisminucion.push(-val);       
      }
      acumulado += val;
      dataTotal.push(0);
    } else {
      // Última barra: LCOH
      assistData.push(0);
      dataAumento.push(0);
      dataDisminucion.push(0);
      dataTotal.push(val);
    }
  }


    

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      formatter: (params) => {
        const categoryName = params[0].name;
        let value = 0;

        // Buscamos en orden de prioridad: Total > Aumento > Disminución
        const total = params.find(p => p.seriesName === 'Total' && p.value !== 0);
        const aumento = params.find(p => p.seriesName === 'Aumento' && p.value !== 0);
        const disminucion = params.find(p => p.seriesName === 'Disminución' && p.value !== 0);

        if (total) {
            value = total.value;
            return `${categoryName}: ${value.toFixed(4)}`;
        } else if (aumento) {
            value = aumento.value;
            return `${categoryName}: ${value.toFixed(4)}`;
        } else if (disminucion) {
            value = -disminucion.value;
            return `${categoryName}: ${value.toFixed(4)}`;
        } else {
            // Si no hay valor (caso muy raro)
            return `${categoryName}: 0.0000`;
        }
    },

    },
    legend: {
      data: [
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.aumento'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.disminucion'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.total')
  ],
    },
    grid: { left: '3%', right: '4%', bottom: '25%', containLabel: true },
    xAxis: {
      type: 'category',
      data: categorias.map(c => c.name),
      axisLabel: {
        rotate: 15,
        fontSize: 12
      },
    },
    yAxis: {
      type: 'value',
      name: '€/kg H2',
    },
    series: [
      {
        name: 'assist',
        type: 'bar',
        stack: 'total',
        itemStyle: { borderColor: 'transparent', color: 'transparent' },
        emphasis: { itemStyle: { borderColor: 'transparent', color: 'transparent' } },
        data: assistData,
      },
      {
        name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.aumento'),
        type: 'bar',
        stack: 'total',
        itemStyle: { color: '#003f5c' },
        label: {
          show: true,
          position: 'top',
          formatter: (p) => (p.value !== 0 ? p.value.toFixed(4) : ''),
        },
        data: dataAumento,
      },
      {
        name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.disminucion'),
        type: 'bar',
        stack: 'total',
        itemStyle: { color: '#ff7f0e' },
        label: {
          show: true,
          position: 'top',
          formatter: (p) => (p.value !== 0 ? `-${p.value.toFixed(4)}` : ''),
        },
        data: dataDisminucion,
      },
      {
        name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.total'),
        type: 'bar',
        stack: 'total',
        itemStyle: { color: '#006400' },
        label: {
          show: true,
          position: 'top',
          formatter: (p) => (p.value !== 0 ? p.value.toFixed(4) : ''),
        },
        data: dataTotal,
      },
    ],
  };
},




    graficaCashflow() {
  if (!this.datos_sal_an2.length) return {};

  const anios = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => d.Year);

  const capex = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.CAPEX_H2) || 0);
  const capexRevamping = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.CAPEX_REV) || 0);
  const subvencion = this.datos_sal_an
    .filter(d => d.Year !== 'TOTAL')
    .map(d => -(parseFloat(d.CAPEX_SUBV) || 0));

  const subvencion_uni = this.datos_sal_an
    .filter(d => d.Year !== 'TOTAL')
    .map(d => -(parseFloat(d.H2V_SUBV) || 0));
  const capexRES = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.CAPEX_RES) || 0);

  const opexElec = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.OPEX_ELEC) || 0);
  const opexH2 = this.datos_sal_an.filter(d => d.Year !== 'TOTAL').map(d => -((parseFloat(d.C_AGUA) || 0) + (parseFloat(d.C_OYMEL) || 0) + (parseFloat(d.C_OYMPL) || 0)));
  const opexRES = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.OPEX_RES) || 0);

  const ingresosElec = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.ING_ELEC) || 0);
  const ingresosH2verde = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.ING_H2V) || 0);
  const ingresosH2lowcarbon = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.ING_H2L) || 0);
  const ingresosVallowcarbon = this.datos_sal_an.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.I_ExLC) || 0);

  const cfTotal = this.datos_sal_an2.filter(d => d.Year !== 'TOTAL').map(d => parseFloat(d.CF_TOTAL) || 0);

  return {
    title: {
      text: 'Cashflow',
      left: 'center',
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
      },
    },
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    legend: {
      orient: 'horizontal',
      top: 'bottom', 
      itemGap: 10, 
      textStyle: { fontSize: 12 },
      data: [
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capex'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capexRevamping'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.subvencion'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.subvencion_uni'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capexRES'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexElec'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexH2'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexRES'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosElec'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosH2verde'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosH2lowcarbon'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosVallowcarbon'),
        this.$t('simulacion.modulo.resultado.flujos-caja.graficas.cfTotal')
      ],
    },
    grid: {
      left: '5%',
      right: '5%',
      bottom: 80, 
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: anios,
      axisLabel: {
        rotate: 15, 
        fontSize: 12,
      },
    },
    yAxis: {
      type: 'value',
      name: 'M€',
      nameTextStyle: { fontSize: 14 },
    },
    series: [
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capex'), type: 'bar', stack: 'cashflow', data: capex, itemStyle: { color: '#4c78a8' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capexRevamping'), type: 'bar', stack: 'cashflow', data: capexRevamping, itemStyle: { color: '#72b7b2' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.subvencion'), type: 'bar', stack: 'cashflow', data: subvencion, itemStyle: { color: '#f2cf5b' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.subvencion_uni'), type: 'bar', stack: 'cashflow', data: subvencion_uni, itemStyle: { color: '#b89111' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.capexRES'), type: 'bar', stack: 'cashflow', data: capexRES, itemStyle: { color: '#e45756' } },

      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexElec'), type: 'bar', stack: 'cashflow', data: opexElec, itemStyle: { color: '#a6cee3' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexH2'), type: 'bar', stack: 'cashflow', data: opexH2, itemStyle: { color: '#33a02c' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.opexRES'), type: 'bar', stack: 'cashflow', data: opexRES, itemStyle: { color: '#b2df8a' } },

      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosElec'), type: 'bar', stack: 'cashflow', data: ingresosElec, itemStyle: { color: '#ff7f0e' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosH2verde'), type: 'bar', stack: 'cashflow', data: ingresosH2verde, itemStyle: { color: '#e377c2' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosH2lowcarbon'), type: 'bar', stack: 'cashflow', data: ingresosH2lowcarbon, itemStyle: { color: '#D2D2D2' } },
      { name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.ingresosVallowcarbon'), type: 'bar', stack: 'cashflow', data: ingresosVallowcarbon, itemStyle: { color: '#696767' } },
      { 
        name: this.$t('simulacion.modulo.resultado.flujos-caja.graficas.cfTotal'),
        type: 'line',
        data: cfTotal,
        yAxisIndex: 0,
        lineStyle: { width: 3, color: '#6a0dad' }, 
        symbolSize: 8,
        itemStyle: { color: '#98df8a' }, 
      },
    ]
  };
},



  },
  methods: {
    sumIngresosLCOH(row) {
  const n = v => (row && row[v] != null ? parseFloat(row[v]) : 0);
  return n('LCOH_INGPV') + n('LCOH_INGEOL') + n('LCOH_INGppa1') + n('LCOH_INGppa2') + n('LCOH_INGppa3')+n('LCOH_INGBAT');
},
       
 exportarFlujosCaja() {
  const headers = [
    'Year',
    'CAPEX LCOH',
    'CAPEX RES LCOH',
    'Subvención LCOH',
    'CAPEX Revamping LCOH',
    'OPEX eléctrico LCOH',
    'OPEX planta H2 LCOH',
    'OPEX RES LCOH',
    'Ingresos eléctricos LCOH',
    'Otros ingresos',
    //'Amortización LCOH',
    'LCOH',
    'CAPEX',
    'CAPEX Revamping',
    'Subvención',
    'Subvenciones unitarias',
    'CAPEX RES',
    'OPEX eléctrico',
    'OPEX planta H2',
    'OPEX RES',
    'Ingresos eléctricos',
    'Ingresos H2 verde',
    'Ingresos H2 low-carbon',
    'Ingresos valoración low-carbon',
    'CF operativo pre-tax'
  ];

  // Función para formatear números
  function formatearNumero(v) {
    if (v == null || v === '') return '';
    // Solo cambiar si es un número
    if (typeof v === 'number' || !isNaN(v)) {
      return v.toString().replace('.', ',');
    }
    return v;
  }

  // Filas sin TOTAL
  const datosSalAnFiltrados = this.datos_sal_an
  .filter(d => String(d.Year).trim().toUpperCase() !== 'TOTAL');
  const rows = this.datos_sal_an2
    .filter(d => String(d.Year).trim().toUpperCase() !== 'TOTAL')
    .map((d, index) => {
    const filaSalAn = datosSalAnFiltrados[index] || {};
    const lcohOpexRes =
      (parseFloat(d.LCOH_OPXPV) || 0) +
      (parseFloat(d.LCOH_OPXEOL) || 0) ||
      (parseFloat(d.LCOH_OPXRES) || 0); // fallback si aún viene el campo antiguo
const opexPlantaH2 =
      -(
        (parseFloat(filaSalAn.C_AGUA)  || 0) +
        (parseFloat(filaSalAn.C_OYMEL) || 0) +
        (parseFloat(filaSalAn.C_OYMPL) || 0)
      );
    return [
      d.Year,
      d.LCOH_CPXPL,
      d.LCOH_CPXRES,
      d.LCOH_CPXSBV,
      d.LCOH_CPXRV,
      d.LCOH_OPXEL,
      d.LCOH_OPXPL,
      lcohOpexRes, 
      this.sumIngresosLCOH(d),
      d.LCOH_INGOTR,
      //d.LCOH_AMORT,
      d.LCOH_TOTAL,
      d.CAPEX_H2,
      d.CAPEX_REV,
      -(parseFloat(filaSalAn.CAPEX_SUBV) || 0),
      -(parseFloat(filaSalAn.H2V_SUBV) || 0),
      d.CAPEX_RES,
      d.OPEX_ELEC,
      d.opexPlantaH2 =
      opexPlantaH2,
      d.OPEX_RES,
      d.ING_ELEC,
      d.ING_H2V,
      d.ING_H2L,
      d.I_ExLC,
      d.CF_TOTAL
    ]
     });

  // Fila TOTAL → desde datos_sal_an2_total
  const filaTotal = this.datos_sal_an2_total && this.datos_sal_an2_total.length > 0 ? this.datos_sal_an2_total[0] : null;

  console.log('filaTotal.LCOH_CPXPL:', filaTotal?.LCOH_CPXPL);
  console.log('filaTotal.LCOH_OPXEL:', filaTotal?.LCOH_OPXEL);

  if (filaTotal) {
    const lcohOpexResTotal =
  (parseFloat(filaTotal.LCOH_OPXPV) || 0) +
  (parseFloat(filaTotal.LCOH_OPXEOL) || 0) ||
  (parseFloat(filaTotal.LCOH_OPXRES) || 0); // fallback
  
  const opexPlantaH2Total = rows.reduce((acc, row) => {
    const valor = parseFloat(row[15]); // índice de 'OPEX planta H2' 
    return acc + (isNaN(valor) ? 0 : valor);
  }, 0);
  const datosSalAnFiltrados = this.datos_sal_an
    .filter(d => String(d.Year).trim().toUpperCase() !== 'TOTAL');

  const sumaSalAn = (campo) =>
    datosSalAnFiltrados.reduce((acc, fila) => {
      return acc + (parseFloat(fila[campo]) || 0);
    }, 0);

    const filaTotalCsv = [
      'TOTAL',
      filaTotal.LCOH_CPXPL,
      filaTotal.LCOH_CPXRES,
      filaTotal.LCOH_CPXSBV,
      filaTotal.LCOH_CPXRV,
      filaTotal.LCOH_OPXEL,
      filaTotal.LCOH_OPXPL,
      lcohOpexResTotal,
      this.sumIngresosLCOH(filaTotal),
      filaTotal.LCOH_INGOTR,
      //filaTotal.LCOH_AMORT,
      filaTotal.LCOH_TOTAL,
      filaTotal.CAPEX_H2,
      filaTotal.CAPEX_REV,
      -sumaSalAn('CAPEX_SUBV'),
      -sumaSalAn('H2V_SUBV'),
      filaTotal.CAPEX_RES,
      filaTotal.OPEX_ELEC,
      opexPlantaH2Total,
      filaTotal.OPEX_RES,
      filaTotal.ING_ELEC,
      filaTotal.ING_H2V,
      filaTotal.ING_H2L,
      filaTotal.I_ExLC,
      filaTotal.CF_TOTAL
    ];

    rows.push(filaTotalCsv);
  } else {
    console.warn(' No se encontró la fila TOTAL en datos_sal_an2_total');
  }

  const BOM = '\ufeff';

  const csvContent = BOM + 
    headers.join(';') + '\n' + 
    rows.map(row => row.map(v => `"${formatearNumero(v)}"`).join(';')).join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'flujos_caja.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

},


  components: {
    ComponenteGrafica,
  },
};
</script>

<style scoped>

.my-cashflow-table {
  width: 100%;
  border-collapse: collapse;
}

.my-cashflow-table th,
.my-cashflow-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: right;
}

.my-cashflow-table th {
  background-color: #f2f2f2;
  text-align: center;
  font-weight: bold;
}

.my-cashflow-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>
